export const NOTIFICATION_TYPES = {
    NEW_BOOKING_REQUEST: 'new_booking_request',
    SETTLED_PAYMENT: 'settled_payment',
    PAYOUT_PAID: 'payout_paid',
};

/**
 * @param {Object} additionalData - Notification additional data
 * @returns {string|null} Route path or null
 */
export const getRouteFromNotification = (additionalData) => {
    const { code, type } = additionalData || {};

    if (!code || !type) {
        console.warn('[NotificationRouter] Missing code or type:', { code, type });
        return null;
    }

    const routes = {
        [NOTIFICATION_TYPES.NEW_BOOKING_REQUEST]: `/therapist/my-booking/detail/${code}`,
        [NOTIFICATION_TYPES.SETTLED_PAYMENT]: `/therapist/payment-details/${code}`,
        [NOTIFICATION_TYPES.PAYOUT_PAID]: `/therapist/payout-details/${code}`,
    };

    return routes[type] || null;
};

/**
 * Handle notification click event
 * @param {Object} event - OneSignal notification click event
 */
export const handleNotificationClick = (event) => {
    console.warn('[NotificationRouter] Notification clicked:', event);

    try {
        const notification = event?.notification || event;
        const additionalData = notification?.additionalData || notification?.data || {};

        const route = getRouteFromNotification(additionalData);

        if (!route) {
            console.warn('[NotificationRouter] No route found for notification:', additionalData);
            return;
        }

        window.location.href = route;
    } catch (error) {
        console.error('[NotificationRouter] Error handling notification click:', error);
    }
};
